module.exports = __webpack_public_path__ + "media/customizations/fsr/back-daa1d9ec3004d78803ca795fe065e2ae.jpg";